import { ListItem as MuiListItem, ListItemProps } from "@mui/material";
import React from "react";

export default function ListItem(props: ListItemProps) {
  return <MuiListItem {...props} sx={{ minWidth: 32, ...props.sx }} />;
}
